// src/pages/AdminDashboard.js
import React, { useState } from 'react';
import HeaderLogged from '../components/HeaderLogged';
import Footer from '../components/Footer';
import PendingWithdrawalsTab from './admin/PendingWithdrawalsTab';
import ConfirmedWithdrawalsTab from './admin/ConfirmedWithdrawalsTab';
import BalanceTransactionsTab from './admin/BalanceTransactionsTab';
import UserReportsTab from './admin/UserReportsTab';
import AdminUsersTab from './admin/AdminUsersTab';
import AnalyticsTab from './admin/AnalyticsTab';
import PasswordGate from '../components/PasswordGate';

export default function AdminDashboard() {

  const [authed, setAuthed] = useState(             
    () => sessionStorage.getItem('dashboardAuth') === '1'
  );
  const [activeTab, setActiveTab] = useState('pending'); 

  const tabs = [
    { key: 'pending',     label: 'Pending Withdrawals',       Component: PendingWithdrawalsTab },
    { key: 'confirmed',   label: 'All Confirmed Withdrawals', Component: ConfirmedWithdrawalsTab },
    { key: 'transactions',label: 'All Balance Transactions',  Component: BalanceTransactionsTab },
    { key: 'reports',     label: 'User Reports',              Component: UserReportsTab },
    { key: 'users',       label: 'Users',                     Component: AdminUsersTab },
    { key: 'analytics',   label: 'Analytics',                 Component: AnalyticsTab },
  ];

  const currentTab = tabs.find(t => t.key === activeTab);

  if (!authed) {
    return (
      <PasswordGate
        onSuccess={() => {
          sessionStorage.setItem('dashboardAuth', '1');
          setAuthed(true);
        }}
      />
    );
  }

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <HeaderLogged />

      <main className="flex-1">
        <div className="max-w-6xl mx-auto p-6 space-y-6">

          {/* Tabs Header */}
          <div className="flex space-x-4 border-b">
            {tabs.map(({ key, label }) => (
              <button
                key={key}
                onClick={() => setActiveTab(key)}
                className={`py-2 px-4 -mb-px border-b-2 ${
                  activeTab === key
                    ? 'border-blue-600 text-blue-600 font-semibold'
                    : 'border-transparent text-gray-600'
                }`}
              >
                {label}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div>
            {/* Рендерим компонент выбранного таба */}
            {currentTab && <currentTab.Component />}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
